import $ from 'jquery';

var headerObject = $('.header__wrapper');
var headerContainerObject = $('.header-wrapper');
var headerPosition = headerObject.position();

if (typeof (headerPosition) !== "undefined") {
	$(window).scroll(function (e) {
		var scrollPosition = $(window).scrollTop();

		headerObject.addClass('header-sticky');
		headerContainerObject.addClass('header-container');

		if (scrollPosition <= (headerPosition.top)) {
			headerObject.removeClass('header-sticky');
			headerContainerObject.removeClass('header-container');
		}
	});
}